// ----------------------------------------------------------------------------
// Nombre del Programa : Home
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que valida si se mostrara el home o el inicio de sesion
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import { useSelector } from 'react-redux';
import { Login } from './Login';
import { Loged } from './Loged';
import { getToken } from '../../Utilidades/session';
import { Activepopups } from "../popups/ActivePopups";
import { ActiveBanners } from "../banners/ActiveBanners";

export const Home = () => {
  const iniciado = useSelector((state: any) => state.authUser.loggedIn);
  const validoSesion = useSelector((state: any) => state.authUser.validoSesion);
  return (
    <>
      {(iniciado && validoSesion) ? (<>
        <Activepopups></Activepopups>
        <ActiveBanners></ActiveBanners>
        <Loged></Loged>
      </>) : (
        <Login></Login>
      )}
    </>
  );
};
